<script lang="ts">
    import Step from "../components/wizard/Step.svelte";
    import NextButton from "../components/NextButton.svelte";
    import TwoCols from "../components/TwoCols.svelte";
    import Checkbox from "../components/Checkbox.svelte";
    import ErrorBox from "../components/ErrorBox.svelte";
    import {createEventDispatcher} from "svelte";
    import type {FileWithPath} from "file-selector";
    import {_} from '../services/i18n';
    import {translations} from "../translations";
    import {Utils} from "../util";


    export let code: string = "";

    export let reportType: string;
    export let typeID = null;
    export let source: string;
    export let links: string[];
    export let files: FileWithPath[];
    export let description: string;
    declare var lang: string;

    let termsOfService = false;
    let privacyPolicy = false;

    export let currentStep: number;
    $:{
        if(currentStep == 4){

            console.log("set focus for 4")
        }
    }

    const dispatch = createEventDispatcher();

    export function validate() {
        showErrors = true;

        return termsOfService && privacyPolicy && !code;
    }

    let showErrors = false;
</script>
<Step let:nextStep num={4} {validate}>
    <h1 class="main-heading">{$_('stepSummary.title')}</h1>

    <div class="grid">
        <div>
            <div class="summary-title">{$_('stepType.title')}</div>
        </div>
        <div class="align-right">
            {reportType}
        </div>
        <div>
            <div class="summary-title">{$_('stepSource.title')}</div>
        </div>
        <div class="align-right">
            <!--{source}-->
            <!--workaround for translation keys-->
            {#if (translations.sources[source.replaceAll('-', '')]) !== undefined || (translations.sources[source.replaceAll('-', '')]) != null}
                {Utils.chooseTranslation(translations.sources[source.replaceAll('-', '')])}
            {:else}
                {source}
            {/if}
        </div>
    </div>

    <div class="summary-title">{$_('stepSummary.submittedData')}</div>

    <div class="three-cols">
        {#if typeID != 3}
            <div class="box-container">
                <span>Screenshots</span>
                <div class="summary-box">
                    {#each files as file, i}
                        {#if i > 0}
                            <hr>
                        {/if}
                        <div class="ellipsis">{file.path}</div>
                    {/each}
                </div>
            </div>
        {/if}
        <div class="box-container">
            <span>URLs</span>
            <div class="summary-box">
                {#each links as link, i}
                    {#if i > 0}
                        <hr>
                    {/if}
                    <div class="ellipsis">{link}</div>
                {/each}
            </div>
        </div>
        <div class="box-container">
            <span>{$_('stepSummary.optionalText')}</span>
            <div class="summary-box">
                {description || ''}
            </div>
        </div>
    </div>


    <hr class="spaced-line">

    <TwoCols rightStyle="display: flex; flex-direction: column" ratio={0.4}>
        <svelte:fragment slot="left">
            <!--            <h1 class="main-heading">What code is in the image?</h1>-->

            <!--            second-heading-->
            {#if lang == 'en'}
                <h2 class="red-title">The responsible party and its contact information</h2>

                <p class="info-text">
                    On this page, you can report potential illegal content encountered online. Using the form below,
                    please reply to the various questions and give as much information as possible on the illegal
                    content you wish to report.
                </p>

                <p class="info-text">
                    The report will be registered when you click on the button 'Submit Report',
                    which will appear once you have answered all the questions.
                    The progress bar shows you the stage you have reached in the reporting procedure.
                </p>

                <p class="info-text">The collected information is stored by the National Youth Service (hereinafter
                    "NYS") <strong>on an electronic file and is exclusively used for processing your request via this
                        form</strong>.</p>

                <p class="info-text">This information will only be collected if you give your explicit consent to the
                    NYS and KJT.</p>

                <p class="info-text">Your personal data will be kept for the entire duration of the management and will
                    exclusively be used by the NYS.</p>

                <p class="info-text">
                    According to regulations on data protection, you can exercise for free your right of access,
                    your right to rectification, your right to erasure, your right to restriction,
                    your right of withdrawal and your right to transfer data by contacting the responsible party
                    via the postal or e-mail address below.
                </p>
                <p class="info-text">
                    If the content that you report is found to be illegal, all data will be transmitted to the police.
                </p>
            {/if}
            {#if lang == 'de'}
                <h2 class="red-title">Der Verantwortliche und seine Kontaktdaten</h2>

                <p class="info-text">
                    Diese Seite erlaubt es Ihnen einen möglichen illegalen Inhalt im Internet zu melden. Beim
                    Beantworten der Fragen,
                    bitten wir Sie so viele Informationen wie möglich über den illegalen Inhalt zu geben, den Sie melden
                    möchten.
                </p>

                <p class="info-text">
                    Die Meldung wird gespeichert, wenn Sie den Button „Diesen Inhalt melden“ klicken.
                    Der Button erscheint, wenn Sie auf alle Fragen geantwortet haben.
                    Die Verlaufsleiste gibt Ihre Position im Meldeprozess wieder.
                </p>

                <p class="info-text">Die gesammelten Informationen werden vom Service national de la jeunesse
                    (nachstehend "SNJ") in einer <strong> elektronischen Datei gespeichert und ausschließlich zur
                        Bearbeitung Ihrer Anfrage über dieses Formular verwendet</strong>.</p>

                <p class="info-text">Diese Informationen werden nur erfasst, wenn Sie der SNJ und KJT Ihre ausdrückliche
                    Zustimmung erteilen..</p>

                <p class="info-text">Ihre personenbezogenen Daten werden für die gesamte Dauer der Verwaltung aufbewahrt
                    und ausschließlich vom SNJ verwendet.</p>

                <p class="info-text">
                    Gemäß den Datenschutzbestimmungen, können Sie Ihr Recht auf Auskunft, Berechtigung,
                    Widerspruch, Löschung, Einschränkung der Verarbeitung und auf Datenübertragbarkeit ausüben,
                    indem Sie sich über die nachstehende Postanschrift oder E-mail-Adresse an die zuständige Stelle
                    wenden.
                </p>
                <p class="info-text">
                    Sollten die von Ihnen gemeldeten Inhalte als illegal eingestuft werden,
                    werden alle angegebenen Daten an die Polizei übertragen.
                </p>
            {/if}
            {#if lang == 'fr'}
                <h2 class="red-title">Le responsable et ses coordonnées</h2>

                <p class="info-text">
                    Cette page vous permet de signaler un contenu illégal potentiel rencontré sur Internet.
                    Nous vous invitons à nous fournir autant d’informations que possible sur le contenu illégal
                    potentiel
                    que vous souhaitez signaler dans le formulaire ci-dessous.
                </p>

                <p class="info-text">
                    Le signalement est enregistré lorsque vous aurez cliqué sur le bouton « signaler ce contenu »
                    qui apparaîtra une fois que vous aurez répondu à toutes les questions.
                    La barre de progression vous indique votre position dans le processus de signalement.
                </p>

                <p class="info-text">Les informations recueillies sont enregistrées par le Service national de la
                    jeunesse (ci-après "SNJ") dans un <strong>fichier électronique et sont exclusivement utilisées pour
                        le traitement de votre demande via ce formulaire</strong>.</p>

                <p class="info-text">Ces informations ne seront collectées que si vous donnez votre consentement
                    explicite au SNJ et au KJT.</p>

                <p class="info-text">Vos données personnelles seront conservées pendant toute la durée de la gestion et
                    seront exclusivement utilisées par le SNJ.</p>

                <p class="info-text">
                    Conformément au Règlement général sur la protection des données, vous pouvez exercer votre droit
                    d'accès,
                    droit de rectification, droit de suppression, droit de restriction et droit de portabilité des
                    données,
                    en contactant la partie responsable à l'adresse postale ou électronique ci-dessous.
                </p>
                <p class="info-text">
                    Si le contenu que vous signalez s'avère illégal, toutes les données seront transmises à la police.
                </p>
            {/if}


        </svelte:fragment>
        <svelte:fragment slot="right">
            <div class="checkbox-container">
                <Checkbox bind:checked={termsOfService} key="Enter"

                          label="{$_('stepSummary.protectionTitle')}">
                    <svelte:fragment slot="description">
                        {@html $_('stepSummary.protectionText')}
                    </svelte:fragment>
                </Checkbox>
                <div class:error-box={showErrors && !termsOfService}>
                    <ErrorBox show="{showErrors && !termsOfService}" msg="This field is required"></ErrorBox>
                </div>
            </div>
            <div class="checkbox-container">
                <Checkbox bind:checked={privacyPolicy}  key="Enter"
                          label="{$_('stepSummary.privacyPolicyTitle')}">
                    <svelte:fragment slot="description">
                        {@html $_('stepSummary.privacyPolicyText')}
                    </svelte:fragment>
                </Checkbox>
                <div class:error-box={showErrors && !privacyPolicy}>
                    <ErrorBox show="{showErrors && !privacyPolicy}" msg="This field is required"></ErrorBox>
                </div>
            </div>

            <!-- honey pot input -->
            <input class="user-input" type="text" name="user" bind:value={code}>

            <NextButton nextStep={() => validate() && dispatch('submit')} isSubmit></NextButton>
        </svelte:fragment>
    </TwoCols>

</Step>

<style lang="scss">
  .main-heading {
    margin-bottom: 25px;
  }

  .second-heading {
    margin-top: 120px;
  }

  .user-input {
    visibility: hidden;
    height: 0;
    padding: 0;
  }

  .checkbox-container {
    margin-bottom: 40px;
  }

  .error-box {
    margin-top: 5px;
  }

  hr {
    width: 100%;
    height: 1px;
    background-color: #C8C8C8;
    border: 0 none;
  }

  .spaced-line {
    margin: 3rem 0;
  }

  .summary-title {
    font-family: 'Open Sans', sans-serif;;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;

    color: #000000;

    margin-bottom: 2rem;
  }

  .grid {
    display: grid;
    grid-template-columns: auto auto;
  }

  .align-right {
    text-align: right;
  }

  .summary-box {
    border: 1px solid #c8c8c8;
    border-radius: 5px;
    overflow: auto;
    height: 100%; // fill whole container

    padding: 1em;
  }

  .box-container {
    width: 33.33%;
    height: 300px;

    padding: 0 10px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .three-cols {
    display: flex;
  }



  /* 600px, 900px, 1200px, and 1800px */
  @media (max-width: 1200px) {
    .three-cols {
      flex-direction: column;
    }
    .box-container {
      // flip the layout
      width: 100%;
      padding: 10px 0;

      height: auto; // removes scroll bars and fixes spacing
    }
    .ellipsis {
      white-space: normal; // fixes width issues
    }
  }
</style>
